import apiClient from '../api/client';

export const submitContact = async ({ name, email, phone, subject, message }) => {
  const { data } = await apiClient.post('/contact', { name, email, phone, subject, message });
  return data;
};

export const getContacts = async (params = {}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );
  const { data } = await apiClient.get('/admin/contacts', { params: cleanParams });
  return data;
};

export const getContact = async (id) => {
  const { data } = await apiClient.get(`/admin/contacts/${id}`);
  return data;
};

export const replyToContact = async (id, replyMessage) => {
  const { data } = await apiClient.post(`/admin/contacts/${id}/reply`, { reply_message: replyMessage });
  return data;
};

export const updateContactStatus = async (id, status) => {
  const { data } = await apiClient.patch(`/admin/contacts/${id}/status`, { status });
  return data;
};
